import React from "react";
import './App.css';
import SortingVisualiser from "./Sorting Visualiser/SortingVisualiser";

function App() {
  return (
    <div className="App">
      <SortingVisualiser />
    </div>
  );
}

export default App;
